import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-locale", "data-template-id", "data-businessunit-id", "data-review-languages", "data-style-height", "data-style-width", "data-theme", "data-text-color"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.trustpilot.com/review/bolia.com",
  target: "_blank",
  rel: "noopener"
}, "Trustpilot", -1)
const _hoisted_3 = [
  _hoisted_2
]

import { isReadable } from '@ctrl/tinycolor';
import { computed, ref, onMounted, onUnmounted } from 'vue';
import LazyScript from '@/core/browser/LazyScript.vue';
import siteContextStore from '@/shared/content/site-context.store';
import viewportEvents from '@/core/responsive/viewport/viewport-events.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'Trustpilot',
  props: {
    trustpilotBusinessUnitId: null,
    hexCode: null,
    height: null,
    width: null,
    templateId: null
  },
  setup(__props: any) {

const props = __props as {
    trustpilotBusinessUnitId?: string;
    hexCode?: string;
    height: string;
    width: string;
    templateId: string;
}



const loadScript = ref(false);

const language = computed(() => siteContextStore.settings.language);

const initTrustPilotWidget = (elem: any) => {
    if (window.Trustpilot && elem) {
        window.Trustpilot.loadFromElement(elem);
    }
};

const invertTextColor = computed<boolean>(() => {
    return !!props.hexCode && !isReadable('#000', props.hexCode);
});

const textColor = computed(() => {
    return invertTextColor.value ? '#FFFFFF' : '#191919';
});

const theme = computed(() => {
    return invertTextColor.value ? 'dark' : 'light';
});

function viewportEventHandler(scroll): void {
    if (!loadScript.value && -0.5 * scroll.height < (scroll.scrollY - scroll.height)) {
        loadScript.value = true;
        viewportEvents.removeCallback(viewportEventHandler);
    }
}

onMounted(() => {
    viewportEvents.setCallback(viewportEventHandler);
});

onUnmounted(() => {
    viewportEvents.removeCallback(viewportEventHandler);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loadScript.value)
      ? (_openBlock(), _createBlock(LazyScript, {
          key: 0,
          src: "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref: initTrustPilotWidget,
      class: "trustpilot-widget w-full",
      "data-schema-type": "Organization",
      "data-locale": _unref(language),
      "data-template-id": __props.templateId,
      "data-businessunit-id": __props.trustpilotBusinessUnitId,
      "data-review-languages": _unref(language),
      "data-style-height": __props.height,
      "data-style-width": __props.width,
      "data-theme": _unref(theme),
      "data-font-family": "Montserrat",
      "data-text-color": _unref(textColor)
    }, _hoisted_3, 8, _hoisted_1)
  ], 64))
}
}

})